/* eslint-disable no-console */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(...args: any[]) {
  console.log(...args)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logError(...args: any[]) {
  console.error(...args)
}
